export const initialModal = () => ({
  title: "Welcome to the Memory Test!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        You'll be shown 10 random words for 12 seconds.
      </div>
      <div className="modal-description-contents">
        Try to remember as many as you can — then type them out in the next
        step!
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});

export const endGameModal = (score, missed) => ({
  title: "Time's Up!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        You remembered <strong>{score} out of 10</strong> words!
      </div>
      <div className="modal-description-contents">
        Words you missed:
        <ul
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            listStyle: "none",
            gap: "12px",
          }}
        >
          {missed.map((w, i) => (
            <li
              key={i}
              style={{
                width: "45%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "6px 10px",
              }}
            >
              {w}
            </li>
          ))}
        </ul>
      </div>
    </div>
  ),
  buttonText: "Try Again",
  buttonType: "start",
});
